import React from 'react';
import {Box} from "@mui/system";
import {Form, Image, Modal} from "@douyinfe/semi-ui";
import moment from "moment";
import {Button} from "@mui/material";
import request from "../../../utils/request";
import {AgGridReact} from "ag-grid-react";
import QRCode from 'qrcode';

const UserSupplyAgreementList = ({userinfo}) => {
    const [list,setList] = React.useState([])
    return (
        <div>
            <Box >

                <Form layout={'horizontal'} labelPosition={'inset'} onSubmit={async e=>{
                    const rew = await request('post','/api/getInfo',{
                        url: 'Srapp.Web_User_Infos.UserSupplyAgreementList',
                        ...e,
                        userid:userinfo.userid
                    })
                    setList(rew.data)
                }}>
                    {/*begintime	日期	必须			录入开始时间*/}
                    {/*endtime	日期	必须			录入结束时间*/}
                    {/*type	枚举类型	必须		范围：全部/供气合同	用户资料类型*/}
                    <Form.Input field={'begintime'} label={'开始时间'} type={'date'} initValue={moment().format('YYYY-MM-DD')}/>
                    <Form.Input field={'endtime'} label={'结束时间'} type={'date'} initValue={moment().format('YYYY-MM-DD')}/>
                    {/*<Form.Select field={'type'} initValue={'全部'} label={'用户资料类型'} style={{width: 300}}>*/}
                    {/*    <Form.Select.Option value={'全部'}>全部</Form.Select.Option>*/}
                    {/*    <Form.Select.Option value={'供气合同'}>供气合同</Form.Select.Option>*/}
                    {/*</Form.Select>*/}

                    <Button variant={'contained'} size={'small'} type={'submit'}>搜索</Button>
                </Form>


                <Box mt={3} overflow={'scroll'} height={'60vh'}>
                    <AgGridReact
                        className={'ag-theme-balham'}
                        rowData={list}
                        columnDefs={[
                            // {field: 'id', headerName: 'ID'},
                            {field: 'addtime', headerName: '添加时间'},
                            {field: 'starttime', headerName: '合同开始时间'},
                            {field: 'endtime', headerName: '合同结束时间'},
                            {field: 'memberid', headerName: '会员号'},
                            {field: 'username', headerName: '用户姓名'},
                            {field: 'telephone', headerName: '联系电话'},
                            {field: 'IDno', headerName: '身份证号'},
                            {field: 'workplace', headerName: '工作单位'},
                            {field: 'address', headerName: '详细地址'},
                            {field: 'attributiondepartment', headerName: '归属部门'},
                            {field: 'salesman', headerName: '业务员'},
                            {field: 'version', headerName: '版本'},
                            {field: 'remarks', headerName: '备注'},
                            {field: 'department', headerName: '部门'},
                            {field: 'operator', headerName: '操作人'},
                            {field: 'state', headerName: '状态'},

                            {field: 'electronicagreementimgid', pinned:'right', headerName: '电子协议', cellRendererFramework: ({data}) => 
                                data.electronicagreementimgid ? <Button
                                    onClick={async ()=>{
                                        const rew = await request('post', '/api/getInfo', {
                                            url: 'Srapp.Action.GetImgList',
                                            id: JSON.stringify([data.electronicagreementimgid])
                                        })
                                        
                                        // 生成二维码
                                        const generateQRCode = async (url) => {
                                            try {
                                                const qrCodeDataURL = await QRCode.toDataURL(url, {
                                                    width: 200,
                                                    margin: 2,
                                                    color: {
                                                        dark: '#000000',
                                                        light: '#FFFFFF'
                                                    }
                                                });
                                                return qrCodeDataURL;
                                            } catch (err) {
                                                console.error('生成二维码失败:', err);
                                                return null;
                                            }
                                        };
                                        
                                        Modal.info({
                                            title: '电子协议',
                                            width: 800,
                                            content: <div>
                                                {rew.data.map((item, index) => {
                                                    return <Box key={index} mb={3}>
                                                        <Box display="flex" gap={2}>
                                                            <Box>
                                                                <Image src={item.imgurl}
                                                                       width={300}
                                                                       height={450}/>
                                                            </Box>
                                                            <Box>
                                                                <Box fontSize={16} mb={2}>协议二维码</Box>
                                                                <Box id={`qrcode-${index}`} mb={2}></Box>
                                                                <Button 
                                                                    variant="outlined" 
                                                                    size="small"
                                                                    onClick={async () => {
                                                                        const qrCodeDataURL = await generateQRCode(item.imgurl);
                                                                        if (qrCodeDataURL) {
                                                                            const qrContainer = document.getElementById(`qrcode-${index}`);
                                                                            if (qrContainer) {
                                                                                qrContainer.innerHTML = `<img src="${qrCodeDataURL}" alt="二维码" style="width: 200px; height: 200px;"/>`;
                                                                            }
                                                                        }
                                                                    }}
                                                                >
                                                                    生成二维码
                                                                </Button>
                                                                <Box mt={2}>
                                                                    <Button 
                                                                        variant="outlined" 
                                                                        size="small"
                                                                        onClick={() => {
                                                                            window.open(item.imgurl, '_blank');
                                                                        }}
                                                                    >
                                                                        查看原图
                                                                    </Button>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                })}
                                            </div>,
                                            onOk: () => {},
                                        })
                                    }}
                                >查看电子协议</Button> : null
                            },
                            {field: 'paperprotocolimgids', pinned:'right', headerName: '纸质协议', cellRendererFramework: ({data}) => 
                                data.paperprotocolimgids && data.paperprotocolimgids.length > 0 ? <Button
                                    onClick={async ()=>{
                                        const rew = await request('post', '/api/getInfo', {
                                            url: 'Srapp.Action.GetImgList',
                                            id: JSON.stringify(data.paperprotocolimgids)
                                        })
                                        Modal.info({
                                            title: '纸质协议',
                                            content: <div>
                                                {rew.data.map((item, index) => {
                                                    return <Box key={index}>
                                                        <Box fontSize={16} mb={2}>协议图片 {index + 1}</Box>
                                                        <Image src={item.imgurl}
                                                               width={300}
                                                               height={450}/>
                                                    </Box>
                                                })}
                                            </div>,
                                            onOk: () => {},
                                        })
                                    }}
                                >查看纸质协议</Button> : null
                            },


                        ]}
                        defaultColDef={{
                            resizable: true,
                            sortable: true,
                            filter: 'agTextColumnFilter',
                            floatingFilter: true,
                        }}
                        onFirstDataRendered={(params) => {
                            params.api.sizeColumnsToFit();
                        }}
                    />
                </Box>
            </Box>
        </div>
    );
};

export default UserSupplyAgreementList;
